/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AccommodationExtraApiDto {
  productCode?: string;
  type?: AccommodationExtraApiDto.TypeEnum;
  roomType?: string;
  bathroomType?: string;
  mealsPlan?: string;
  description?: string;
  galleryUrls?: Array<string>;
}
export namespace AccommodationExtraApiDto {
  export const TypeEnum = {
    HOMESTAY: 'HOMESTAY',
    RESIDENCE: 'RESIDENCE',
    APARTMENT: 'APARTMENT',
    CAMPUS: 'CAMPUS',
    NO_ACCOMMODATION: 'NO_ACCOMMODATION',
    OTHER: 'OTHER',
  } as const;
  export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
